import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { GeometricField } from '../visuals/GeometricField';
import { TalentNetwork } from '../visuals/TalentNetwork';
import { Button } from '../ui/Button';
const chips = [{
  label: 'Leadership',
  className: 'left-[6%] top-[18%]'
}, {
  label: 'Talent',
  className: 'right-[4%] top-[42%]'
}, {
  label: 'Opportunity',
  className: 'bottom-[14%] left-[22%]'
}];
export function HeroSection() {
  const reduce = useReducedMotion();
  const enter = (delay: number) => ({
    initial: reduce ? false : {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1] as const,
      delay
    }
  });
  return <section className="relative overflow-hidden bg-midnight text-white" data-id="element-187" data-mp="bczymb84b9ed">
      <GeometricField className="opacity-70" data-id="element-188" data-mp="21ontod8he8kb" />
      <div className="container-page relative grid items-center gap-6 pb-32 pt-12 md:pt-16 lg:grid-cols-12 lg:pb-40" data-id="element-189" data-mp="21ow3fw9b4xra">
        <div className="relative z-10 lg:col-span-6" data-id="element-190" data-mp="25nvfs1xdbwsr">
          <motion.p {...enter(0)} className="mb-6 text-sm font-medium text-gold-300" data-id="element-191" data-mp="2ad787e5k02bt">
            Executive Search · Professional Recruitment · Talent Advisory
          </motion.p>
          <motion.h1 {...enter(0.05)} className="font-display text-[44px] font-semibold leading-[1.02] sm:text-6xl lg:text-[76px]" data-id="element-192" data-mp="2k4lbzy4jfoar">
            Exceptional Talent.
            <br data-id="element-193" data-mp="2f7bfjyiqecdf" />
            Strategic Leadership.
            <br data-id="element-194" data-mp="1rgfsfep805ci" />
            <span className="text-gold-300" data-id="element-195" data-mp="1rfwkmqtaaxc7">Lasting Impact.</span>
          </motion.h1>
          <motion.p {...enter(0.1)} className="mt-7 max-w-xl text-lg leading-relaxed text-white/75" data-id="element-196" data-mp="1mhlbkiatcqv1">
            Corventa Talent Search connects organisations with exceptional professionals and leadership talent through a thoughtful,
            research-led recruitment approach.
          </motion.p>
          <motion.div {...enter(0.15)} className="mt-10 flex flex-wrap gap-3" data-id="element-197" data-mp="3crehetsvhbr3">
            <Button to="/employers" size="lg" arrow data-id="element-198" data-mp="37ufnocd4f6tf">
              Find Talent
            </Button>
            <Button to="/jobs" size="lg" variant="outlineLight" data-id="element-199" data-mp="3exm6314a5n1s">
              Explore Opportunities
            </Button>
          </motion.div>
        </div>
        <div className="relative h-[320px] sm:h-[420px] lg:col-span-6 lg:h-[580px]" data-id="element-200" data-mp="3jxqq314eczwr">
          <TalentNetwork className="absolute inset-0" data-id="element-201" data-mp="3osxobtewdcea" />
          {chips.map(c => <span key={c.label} aria-hidden="true" className={`absolute hidden items-center gap-2 rounded-full border border-white/15 bg-midnight-800/70 px-3 py-1.5 text-xs text-white/85 backdrop-blur sm:flex ${c.className}`} data-id="element-202" data-mp="3ttlg4hay9x9k">
              <span className="h-1.5 w-1.5 rotate-45 bg-gold" data-id="element-203" data-mp="363r23wewa2nq" />
              {c.label}
            </span>)}
        </div>
      </div>
    </section>;
}